import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox, Radio, Well } from 'react-bootstrap';
import ScheduleFilters from '../common/ScheduleFilters';
import ScheduleDForm from './ScheduleDForm';
import './ScheduleD.less';
import MoneyFormat from '../common/MoneyFormat';
import currencyConversion from '../../utils/currencyConversion';
import EditCopyPasteSchedule from '../common/EditCopyPasteSchedule.jsx';
import ScheduleVerifyToolbar from '../common/ScheduleVeriyToolbar';

const getScheduleDdata = ({ data, viewFilters }) => {
  const { creditors = [], total_claims_amount_cents = 0 } = data;
  const { value_from = '', value_to = '', keyword = '' } = viewFilters;
  const searchWords = keyword
    .toLowerCase()
    .split(' ')
    .filter((p) => p !== '')
    .reverse();
  const inRange = (value) =>
    (value_from ? currencyConversion.toDollars(value) >= value_from : true) &&
    (value_to ? currencyConversion.toDollars(value) <= value_to : true);
  const filteredCreditors = creditors.map((creditor) => {
    const text = Object.values(creditor).join(' ').toLowerCase();
    const visible =
      (_.isEmpty(searchWords) || _.every(searchWords, (word) => text.indexOf(word) > -1)) &&
      (inRange(creditor.claim_amount_cents) || inRange(creditor.collateral_amount_cents));
    return {
      ...creditor,
      visible,
    };
  });
  const hasFilteredCreditors = filteredCreditors.filter(({ visible }) => visible).length > 0;
  if (!hasFilteredCreditors) {
    return <Well bsSize="small">No results for searched term, try to search something different.</Well>;
  }
  return (
    <table id="secured-creditors">
      <thead>
        <tr>
          <th>Creditors Who Have Secured Claims</th>
        </tr>
      </thead>
      <tbody>
        {filteredCreditors.map((item, key) => (
          <tr key={key} style={{ display: item.visible ? 'table-row' : 'none' }}>
            <td>
              <table>
                <thead>
                  <tr>
                    <td colSpan="2">2.{key + 1}</td>
                    <td className="total-claim">
                      <label htmlFor="">
                        <span className="label">Amount of claim</span>
                        <span className="schedule-tips">Do not deduct the value of collateral.</span>
                      </label>
                    </td>
                    <td className="collateral-value">
                      <label htmlFor="">
                        <span className="label">Value of collateral that supports this claim</span>
                      </label>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <label htmlFor="">
                        <span className="label">Creditor's name</span>
                      </label>
                      <br />
                      <span id="address">{item.creditor_name}</span>
                    </td>
                    <td>
                      <label htmlFor="">
                        <span className="label">Describe debtor’s property that is subject to a lien</span>
                      </label>
                      <br />
                      <span id="property" style={{ whiteSpace: 'pre-wrap' }}>
                        {item.property_description}
                      </span>
                    </td>
                    <td className="money">
                      <span id="claim-amount">{MoneyFormat(item.claim_amount_cents)}</span>
                    </td>
                    <td className="money">
                      <span id="collateral-value">{MoneyFormat(item.collateral_amount_cents)}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="">
                        <span className="label">Creditor's mailing address</span>
                      </label>
                      <br />
                      {item.creditor_address_street}
                      <br />
                      {item.creditor_address_city} {item.creditor_address_state} {item.creditor_address_zip_code}
                      <br />
                      {item.creditor_address_country}
                    </td>
                    <td>
                      <label htmlFor="">
                        <span className="label">Describe the lien</span>
                      </label>
                      <div style={{ whiteSpace: 'pre-wrap' }}>{item.lien_description || ''}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="">
                        <span className="label">Creditor's email address, if known</span>
                      </label>
                      <br />
                      {item.creditor_email || ''}
                    </td>
                    <td>
                      <label htmlFor="">
                        <span className="label">Is creditor an insider or related party?</span>
                      </label>
                      <br />
                      <Radio
                        name={`is_creditor_an_insider${key}`}
                        checked={item.is_creditor_an_insider === false}
                        readOnly
                      >
                        No
                      </Radio>
                      <Radio name={`is_creditor_an_insider${key}`} checked={item.is_creditor_an_insider} readOnly>
                        Yes
                      </Radio>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="">
                        <span className="label">Date debt was incurred</span>
                      </label>
                      <br />
                      {item.debt_date || ''}
                    </td>
                    <td rowSpan="2" colSpan={2}>
                      <label htmlFor="">
                        <span className="label">Is anyone else liable on this claim?</span>
                      </label>
                      <br />
                      <Radio
                        name={`is_anyone_else_liable${key}`}
                        checked={item.is_anyone_else_liable === false}
                        readOnly
                      >
                        No
                      </Radio>
                      <Radio name={`is_anyone_else_liable${key}`} checked={item.is_anyone_else_liable} readOnly>
                        Yes.{' '}
                        <small>
                          Fill out <em>Schedule H: Codebtors</em> (Official Form 206H).
                        </small>
                      </Radio>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="">
                        <span className="label">Last 4 digits of account number</span>
                      </label>
                      <br />
                      {item.account_number_last_4_digits || ''}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="">
                        <span className="label">Do multiple creditors have an interest in the same property?</span>
                      </label>
                      <Radio
                        name={`has_multiple_creditor_interest${key}`}
                        checked={!item.has_multiple_creditor_interest}
                        readOnly
                      >
                        No
                      </Radio>
                      <Radio
                        name={`has_multiple_creditor_interest${key}`}
                        checked={item.has_multiple_creditor_interest}
                        readOnly
                      >
                        Yes
                      </Radio>
                      <div
                        className="is-multiple-creditors-interested-yes"
                        style={{ display: item.has_multiple_creditor_interest ? 'inherit' : 'none' }}
                      >
                        {key === 0 ? (
                          <React.Fragment>
                            <span className="creditor-priority">
                              Specify each creditor, including this creditor, and its relative priority
                            </span>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{item.creditor_priority}</div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="has-specified-creditor-priority">
                              Have you already specified the relative priority?
                            </span>

                            <Radio
                              name={`has-specified-creditor-priority${key}`}
                              checked={!item.has_already_specified_creditor_priority}
                              readOnly
                            >
                              No
                            </Radio>
                            <Radio
                              name={`has-specified-creditor-priority${key}`}
                              checked={item.has_already_specified_creditor_priority}
                              readOnly
                            >
                              Yes
                            </Radio>

                            <div
                              className="has-specified-creditor-priority-no"
                              style={{ display: !item.has_already_specified_creditor_priority ? 'inherit' : 'none' }}
                            >
                              <span className="creditor-priority">
                                Specify each creditor, including this creditor, and its relative priority
                              </span>
                              {item.creditor_priority}
                            </div>
                            <div
                              className="has-specified-creditor-priority-yes"
                              style={{ display: item.has_already_specified_creditor_priority ? 'inherit' : 'none' }}
                            >
                              <span className="creditor-priority">
                                The relative priority of creditors is specified on lines
                              </span>
                              <br />
                              {item.creditor_priority_specified_on_line}
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    </td>
                    <td>
                      <label htmlFor="">
                        <span className="label">As of the petition filing date, the claim is:</span>
                        <span className="schedule-tips">Check all that apply.</span>
                      </label>
                      <Checkbox name="is_contingent" checked={item.is_contingent} readOnly>
                        Contingent
                      </Checkbox>
                      <Checkbox name="claim_type" checked={item.is_unliquidated} readOnly>
                        Unliquidated
                      </Checkbox>
                      <Checkbox name="claim_type" checked={item.is_disputed} readOnly>
                        Disputed
                      </Checkbox>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td>
            <table>
              <tbody>
                <tr>
                  <td>
                    <span className="label">
                      Total of the dollar amounts from Part 1, Column A, including the amounts from the Additional Page,
                      if any.
                    </span>
                  </td>
                  <td className="money total">
                    <span id="total-claim">{MoneyFormat(total_claims_amount_cents)}</span>
                  </td>
                  <td className="money" />
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

function ScheduleD(props) {
  const [viewFilters, setViewFilters] = useState({});
  const scheduleFiltersProps = {
    viewFilters,
    setViewFilters,
  };

  const { type, schedule, editScheduleForm, canEdit, can_see_details, onSubmit, toggleScheduleForm, onPastedData } =
    props;

  const tableData = schedule.data || {};
  const noDataFound = schedule.data === null ? 'There is no Schedule D for this case.' : schedule.empty || null;

  if (noDataFound && !editScheduleForm) {
    return (
      <div id="ir-search-schedule-d-results">
        <Well bsSize="small">{noDataFound}</Well>
        {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
        {canEdit && (
          <EditCopyPasteSchedule
            schedule={{ schedule_type: 'd' }}
            onPastedData={onPastedData}
            toggleScheduleForm={toggleScheduleForm}
          />
        )}
      </div>
    );
  }

  return (
    <div className={type}>
      {can_see_details && (
        <React.Fragment>
          <div id="schedule-d">
            <div id="ir-search-schedule-d-results">
              {editScheduleForm ? (
                <ScheduleDForm
                  {...props}
                  // editScheduleForm could be a draft object
                  schedule={editScheduleForm === true ? schedule : editScheduleForm}
                  isDraft={editScheduleForm !== true}
                  onSubmit={onSubmit}
                  onCancel={toggleScheduleForm}
                />
              ) : (
                <React.Fragment>
                  <ScheduleFilters {...scheduleFiltersProps} />
                  {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
                  {canEdit && (
                    <EditCopyPasteSchedule
                      onPastedData={onPastedData}
                      schedule={schedule}
                      toggleScheduleForm={toggleScheduleForm}
                    />
                  )}
                  {getScheduleDdata({ data: tableData, viewFilters })}
                </React.Fragment>
              )}
              {canEdit && !editScheduleForm && (
                <div className="editable">
                  <button className="btn btn-primary" onClick={toggleScheduleForm}>
                    Edit
                  </button>
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

ScheduleD.defaultProps = {
  type: 'schedule_d',
  scheduleFiltersProps: {},
  viewFilters: {},
  keyword: '',
  value_from: '',
  value_to: '',
};

ScheduleD.propTypes = {
  schedule: PropTypes.any.isRequired,
  type: PropTypes.string,
  scheduleFiltersProps: PropTypes.object,
  viewFilters: PropTypes.object,
  keyword: PropTypes.string,
  value_to: PropTypes.string,
  value_from: PropTypes.string,
  editScheduleForm: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  can_see_details: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggleScheduleForm: PropTypes.func.isRequired,
};

export default ScheduleD;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_d/ScheduleD.jsx